<template>
    <div>
        <Home v-if="$route.query.prod_kat == 2" />
        <Home2 v-else-if="$route.query.prod_kat == 1"/>
        <div v-else>Test</div>
        <div id=MenuSub>
            <button v-on:click="finishDesign" id="PrimaryButton">Fertig</button>            
        </div>
    </div>
</template>

<script>
import store from "@/store/index"
import Home from '@/views/Home'
import Home2 from '@/views/Home2'


export default {
    components: {
        Home,
        Home2
    },
    mounted: function () {
        this.$store.dispatch('setActiveProduct',this.$route.query.prod_id)         
        //console.log(this.$store.state.activeProduct)       
        this.$store.dispatch('registerBackend')
        
    },
    methods: {
        finishDesign: function () {               
            setTimeout(() =>  this.$store.dispatch('takePreviewImg'), 300);
            if(this.$route.query.prod_kat == 2) {
                setTimeout(() =>  this.$store.dispatch('uploadImage'), 300);
            }
            setTimeout(() =>  this.$store.dispatch('addToCart'), 800);
            
        },        
    }
}
</script>
<style lang="scss" scoped>
#PrimaryButton {
  //display: inline-block;
  
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  line-height: 16px;
  //height: $buttonHeight;
  background-color: #faba18;
  border: 1px solid #faba18;
  color: white;
  padding: 5px 10px;
  //margin: 0 auto;
  //box-shadow: 1px 1px 1px 0px rgba($black, 0.2);
  
  outline: 0;
  width: 100%;
  
  
  position: relative; 
  &:hover {
	cursor: pointer;
	background-color:white;
	color:#faba18;
	border: 1px solid #faba18;
    //box-shadow: 1px 1px 6px 0px rgba($black, 0.6);
  }
}  
#MenuSub {
  width: 700px;
  max-width: 80%;
  //margin: 0 auto;
  position: relative;
}

</style>